import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { MatTableDataSource } from '@angular/material';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';
import { SemsoSnackbarService } from '../../semso-snackbar.service';
import { HttpError } from '../../errors';
import { StudentsService } from '../../students.service';
import { AssignmentForm } from 'app/exam-preparation/assignment-form';
import { SemsoEncryptionModule } from 'app/encryption/encryption.module';
import { CoreTask } from '../core-task';

@Component({
  selector: 'app-exam-preparation-student',
  templateUrl: './exam-preparation-student.component.html',
  styleUrls: ['./exam-preparation-student.component.scss']
})
export class ExamPreparationStudentComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<boolean>();
  private studentnummerEncrypted: string;
  private creboId: string;
  private visible: true;
  public dataSource: MatTableDataSource<AssignmentForm>;
  public displayedColumns = ['formulierCode', 'formulierOmschrijving', 'startButton'];

  private keuzedelenTasksSubject = new Subject<CoreTask[]>();
  public keuzedelenTasks$ = this.keuzedelenTasksSubject.asObservable();

  constructor(
    private route: ActivatedRoute,
    private studentService: StudentsService,
    private router: Router,
    private snackbar: SemsoSnackbarService,
    private encryption: SemsoEncryptionModule) { }

  ngOnInit() {    
    this.dataSource = new MatTableDataSource([]);
    this.route.params
      .takeUntil(this.destroy$)
      .subscribe(params => {
        this.studentnummerEncrypted = params['studentIdEncrypted'];
        this.creboId = params['creboId'];
        
        this.studentService.isCreboGeldig(params['studentIdEncrypted'], params['creboId']).subscribe(data => {
          this.visible = data;
        }, e => {
          this.error(`Fout bij het ophalen van de geldigheid crebo voor student: ${this.encryption.decrypt(this.studentnummerEncrypted)}`);
        });
                
        this.studentService.getAssignmentFormsOfStudent(params['studentIdEncrypted'], params['creboId'])
          .takeUntil(this.destroy$)
          .subscribe(data => {
            const formsNotStatusThree = data.filter((item) => {
              return (item.formulierCode === 'Vaststelling' && item.akkoordExamenCommissie === true)
                || (item.formulierCode === 'Opdracht' && item.akkoordExamenCommissie === true);
            });

            if (formsNotStatusThree.length === 2) {
              this.router.navigate(['../crebos'], { relativeTo: this.route, preserveQueryParams: true })
            }

            this.dataSource.data = data;
          }, e => {
            this.error(`Fout bij het ophalen van de opdrachten voor student: ${this.encryption.decrypt(this.studentnummerEncrypted)}`);
          });
      });
  }

  ngOnDestroy() {
    this.destroy$.next(false);
  }

  applyFilter() {
  }

  startForm(element: AssignmentForm) {
    this.studentService.startForm(this.studentnummerEncrypted, element.formulierCode, this.creboId)
      .takeUntil(this.destroy$)
      .subscribe(data => {
        this.router.navigate(['examination-preparation', this.studentnummerEncrypted, this.creboId,
          this.determineRoute(element.formulierCode), data], { queryParamsHandling: 'merge' })
      }, e => {
        this.error(`Fout bij het starten van nieuw formulier`);
      });
  }

  resumeForm(element: AssignmentForm) {
    this.router.navigate(['examination-preparation', this.studentnummerEncrypted, this.creboId,
      this.determineRoute(element.formulierCode), element.studentOpdrachtFormulierId], { queryParamsHandling: 'merge' });
  }

  private determineRoute(code): string {
    if (code === 'Opdracht') {
      return 'assignment-pvb';
    } else {
      return 'determination-assignment-pvb';
    }
  }

  private error(message) {
    this.snackbar.error(message);
    return new HttpError(message);
  }
}



// WEBPACK FOOTER //
// ./src/app/students/exam-preparation-student/exam-preparation-student.component.ts